import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import Button from '../Button';
import { MenuItem } from '../Menu';

/**
 * `ListAction` component is a part of [ListActions](#!/ListActions) component.
 * It accepts the props of [Button](#!/Button) and [MenuItem](#!/MenuItem) components.
 * @since 3.3.0
 */
var ListAction = function ListAction(_ref) {
  var primary = _ref.primary,
      children = _ref.children,
      tooltip = _ref.tooltip,
      props = _objectWithoutProperties(_ref, ["primary", "children", "tooltip"]);

  var render = function render(children) {
    if (primary) {
      return React.createElement(Button, _extends({
        ghost: true,
        tooltip: children
      }, props));
    }

    return React.createElement(MenuItem, _extends({
      tooltip: tooltip
    }, props), children);
  };

  var unwrap = function unwrap(cb) {
    return cb({
      wrap: function wrap(children) {
        return render(children);
      }
    });
  };

  if (typeof children === 'function') {
    return unwrap(children);
  }

  return render(children);
};

export default ListAction;